/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

import topSearchIndex from './topsearch/index'
import topSearchContext from './topsearch/context'
import topSearchMapping from './topsearch/mapping'
import topSearchProductsRequest from './topsearch/request'
import topSearchCategories from './topsearch/categories'
import topSearchForm from './topsearch/form'
import topSearchDataLayer from './topsearch/datalayer'
import topSearchHeading from './topsearch/heading'

Alpine.data('topSearch', function() {
    return {
        ...window.liveSearchConfig,
        ...topSearchIndex,
        ...topSearchContext,
        ...topSearchCategories,
        ...topSearchForm,
        ...topSearchMapping,
        ...topSearchProductsRequest,
        ...topSearchDataLayer,
        ...topSearchHeading
    }
})
